import { IHTTPCompletedResponse } from '@cian/http-api';

import { TThunkAction } from '../../../types/redux';
import { fetchAddLike, IAddLikeRequest } from '../../../services/likes/addLike';
import { TResponses, IAddLikeResponse } from '../../../services/likes/addLike/types';
import { throwError } from '../../../utils';
import { addLikeSucceed } from './addLikeSucceed';
import { ELikeType } from '../../../types/likes';

interface IAddLike {
  commentId: IAddLikeRequest['object_pk'];
  likeType: ELikeType;
}

export const addLike = ({ commentId, likeType }: IAddLike): TThunkAction<Promise<boolean>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger, config } = context;

    try {
      const { responseBody: response, responseStatusCode: statusCode }: IHTTPCompletedResponse<TResponses> =
        await fetchAddLike({
          httpApi,
          bodyParameters: {
            content_type_model: 'threadedcomment',
            object_pk: commentId,
            vote: likeType,
          },
          config: {
            browserUrl: config.get<string>('backend-content.browserUrl') || '',
          },
        });

      if (statusCode !== 201) {
        throwError({ message: 'Не удалось добавить лайк', statusCode, domain: 'actions.addLike' });

        return false;
      }

      const {
        attributes: { dislikesCount, likesCount },
      } = (response as IAddLikeResponse).data;

      dispatch(
        addLikeSucceed({
          commentId,
          dislikesCount,
          likesCount,
        }),
      );

      return true;
    } catch (e) {
      logger.error(e, {
        domain: 'actions.addLike',
      });

      return false;
    }
  };
};
